import { OpenInNew } from "@mui/icons-material"
import { Autocomplete, Button, ButtonGroup, Paper, ListItem, Typography, styled } from "@mui/material"
import { Box } from "@mui/system"
import { Fragment, memo, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"



import SubmitButton from "../../components/button/SubmitButton"
import { StyledSearchBar, UserSearchBarNormal } from "../../components/inputs/SearchBar"


import { REGIONS_TYPE, USER_ROLES } from "../../utils/constants"
import DataTable from "../../components/tables/DataTable"
import { findObjectKeyByValue, titleCase, toTitleCase } from "../../utils/helper"
import PaddingBoxInDesktop from "../../components/layouts/PaddingBoxInDesktop"
import AsyncDropDown from "../../components/inputs/AsyncDropDown"
import { getRegionApi } from "../../apis/region.api"
import { getCampApi } from "../../apis/camp.api"
import { BENIFICIARY_STATUS } from "../../utils/beneficiary.constant"
import TimeRangeSelector from "../../components/layouts/common/TimeRangeSelector"
import { getProductApi } from "../../apis/product.api"
import AsynSearchBar from "../../components/inputs/AsynSearchBar"
// import { openModal } from "../../store/actions/modalAction"
import CreateController from "./CreateController"
import BeneficiaryCreateButton from "./components/BeneFiciaryCreateButton"
import BenificiaryCounts from "./BenificiaryCounts"
import { getCityApi, getCountryApi, getStateApi } from "../../apis/CountryStateCity.api"
import CustomInput from "../../components/inputs/CustomInput"
// import SheetDonwnloadButton from "./sheet/SheetDonwnloadButton"


const FilterTitleBox = styled(Box)(({ theme }) => ({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    [theme.breakpoints.down('md')]: {
        flexDirection: "column"
    }

}))
const FiltersBox = styled(Box)(({ theme }) => ({
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",

    flexWrap: "wrap",
    [theme.breakpoints.down('md')]: {
        flexDirection: "column"
    }
}))


const ListUi = ({ title, exportzipLoading, filters, setFilters, list, exportLoading, loading, onExportBtnClick, columns, callBackFun, handleDownload }) => {

    const user = useSelector(state => state.user)

    const ahmedabadTalukaList = [
        { id: 1, label: "Daskroi" },
        { id: 2, label: "Sanand" },
        { id: 3, label: "Dholka" },
        { id: 4, label: "Viramgam" },
        { id: 5, label: "Detroj-Rampura" },
        { id: 6, label: "Bavla" },
        { id: 7, label: "Mandal" },
        { id: 8, label: "Barwala" },
        { id: 9, label: "Ahmedabad City" },
    ];

    return (
        <>

            <Box mb={3}>
                <Paper elevation={2} sx={{ width: "100%", padding: 4 }} >
                    <Box mb={3} >
                        <FilterTitleBox>
                            <Typography variant="h5" mb={2} >{title}</Typography>

                            <BeneficiaryCreateButton callBack={callBackFun} />
                        </FilterTitleBox>


                        <FiltersBox mt={3} >
                            <PaddingBoxInDesktop mb={2} sx={{ display: "flex", flex: 1, justifyContent: "flex-end" }}  >
                                <TimeRangeSelector onChange={(newRange) => { setFilters({ ...filters, ...newRange }) }} />
                            </PaddingBoxInDesktop>


                            <PaddingBoxInDesktop mb={2} sx={{ display: "flex", flex: 1, justifyContent: "flex-end" }} pl={2}  >
                                <AsyncDropDown


                                    lazyFun={async (para) => await getCampApi({ ...para, allStatus: true })}

                                    OptionComponent={({ option, ...rest }) => {
                                        return <ListItem {...rest}>{option.name}</ListItem >
                                    }}
                                    onChange={async (changedVal) => {
                                        setFilters({ ...filters, camp: changedVal ? changedVal._id : null, camp_name: changedVal ? changedVal?.name : null })
                                    }}
                                    titleKey={'name'}
                                    valueKey={"_id"}
                                    InputComponent={(params) => <StyledSearchBar placeholder={"Select Camp"} {...params} margin="none" />}
                                />
                            </PaddingBoxInDesktop>

                            <PaddingBoxInDesktop mb={2} sx={{ display: "flex", flex: 1, justifyContent: "flex-end" }} pl={2}  >
                                <AsyncDropDown


                                    lazyFun={async (para) => await getProductApi({ ...para, allStatus: true })}

                                    OptionComponent={({ option, ...rest }) => {
                                        return <ListItem {...rest}>{option.name}</ListItem >
                                    }}
                                    onChange={async (changedVal) => {
                                        setFilters({ ...filters, product: changedVal ? changedVal._id : null, })
                                    }}
                                    titleKey={'name'}
                                    valueKey={"_id"}
                                    InputComponent={(params) => <StyledSearchBar placeholder={"Select Product"} {...params} margin="none" />}
                                />
                            </PaddingBoxInDesktop>
                            {/* <PaddingBoxInDesktop mb={2} sx={{ display: "flex", flex: 1 }} pl={2} >
                                <Autocomplete
                                    disableClearable
                                    onChange={(e, changedVal) => { setFilters({ ...filters, status: changedVal ? changedVal._id : null, }) }}
                                    options={[{ label: 'All', _id: null }, ...Object.keys(BENIFICIARY_STATUS).map((key) => ({ label: titleCase(key), _id: BENIFICIARY_STATUS[key] }))]}

                                    sx={{ width: "100%", display: "flex", "*": { display: "flex", justifyContent: "center" } }}
                                    renderInput={(params) => <StyledSearchBar placeholder="Select Status" {...params} />}
                                />
                            </PaddingBoxInDesktop> */}

                        </FiltersBox>
                        <FilterTitleBox>


                            <PaddingBoxInDesktop mb={2} sx={{ display: "flex", flex: 1, justifyContent: "flex-end" }}  >
                                <AsyncDropDown
                                    // key={filters.district}
                                    // disabled={!}
                                    Value={filters?.country ? { _id: 1, name: filters?.country } : null}
                                    lazyFun={async (para) => await getCountryApi({ ...para, allStatus: true, isName: true })}
                                    OptionComponent={({ option, ...rest }) => {
                                        return <ListItem {...rest}>{option.name}</ListItem >
                                    }}
                                    onChange={async (changedVal) => {
                                        setFilters((prev) => ({
                                            ...prev,
                                            country: changedVal?.name || "",
                                            taluka: "",
                                            state: "",
                                            district: "",
                                            // cityName: "",
                                        }));
                                    }}
                                    titleKey={'name'}
                                    valueKey={"_id"}
                                    InputComponent={(params) => <CustomInput placeholder={"Select Country"} label={"Country"} {...params} margin="none" />}
                                />
                            </PaddingBoxInDesktop>

                            <PaddingBoxInDesktop pl={2} mb={2} sx={{ display: "flex", flex: 1, justifyContent: "flex-end" }}  >
                                <AsyncDropDown
                                    key={filters.state}
                                    // disabled={!}
                                    Value={filters?.state ? { _id: 1, name: filters?.state } : null}
                                    lazyFun={async (para) => await getStateApi({ ...para, allStatus: true, country: filters?.country, isName: true })}
                                    OptionComponent={({ option, ...rest }) => {
                                        return <ListItem {...rest}>{option.name}</ListItem >
                                    }}
                                    onChange={async (changedVal) => {
                                        setFilters((prev) => ({
                                            ...prev,
                                            // state: changedVal?._id || "",
                                            state: changedVal?.name || "",
                                            district: "",
                                            // cityName: "",
                                        }));
                                    }}
                                    titleKey={'name'}
                                    valueKey={"_id"}
                                    InputComponent={(params) => <CustomInput placeholder={"Select State"} label={"State"} {...params} margin="none" />}
                                />
                            </PaddingBoxInDesktop>

                            <PaddingBoxInDesktop pl={2} mb={2} sx={{ display: "flex", flex: 1, justifyContent: "flex-end" }}  >
                                <AsyncDropDown
                                    key={filters.state}
                                    disabled={!(filters.state)}
                                    Value={filters?.district ? { _id: 3, name: filters?.district } : null}
                                    lazyFun={async (para) => await getCityApi({ ...para, allStatus: true, state: filters.state, isName: true })}
                                    OptionComponent={({ option, ...rest }) => {
                                        return <ListItem {...rest}>{option.name}</ListItem >
                                    }}
                                    onChange={async (changedVal) => {
                                        setFilters((prev) => ({
                                            ...prev,
                                            district: changedVal?.name || "",
                                        }));
                                    }}
                                    titleKey={'name'}
                                    valueKey={"_id"}
                                    InputComponent={(params) => <CustomInput placeholder={"Select District"} label={"District"} {...params} margin="none" />}
                                />
                            </PaddingBoxInDesktop>
                        </FilterTitleBox>
                    </Box>
                    <BenificiaryCounts setFilters={setFilters} filters={filters} />

                    <FiltersBox mb={3}>
                        <PaddingBoxInDesktop sx={{ display: "flex", flex: 1 }}  >
                            <Box sx={{ display: "flex", flexWrap: "wrap" }}  >
                                <Box mr={1}>
                                    {/* <SheetDonwnloadButton /> */}
                                    {<SubmitButton loading={exportLoading} variant="contained" onClick={onExportBtnClick} title={"Export CSV"} />}
                                </Box>
                                <Box>
                                    {filters?.camp && <SubmitButton loading={exportzipLoading} variant="contained" onClick={handleDownload} title={"Export zip"} />}
                                </Box>
                            </Box>
                        </PaddingBoxInDesktop>

                        <PaddingBoxInDesktop mb={2} sx={{
                            display: "flex", flex: 1, justifyContent: "flex-end", "*": {
                                justifyContent: "center"
                            }
                        }} pl={2} >

                            <AsynSearchBar

                                fullWidth
                                title="Search By  Name | Phone No "
                                size="small"
                                placeholder={"Search By  Name | Phone No "}
                                defaultValue={filters.search}
                                onChange={(changedVal) => { setFilters({ ...filters, search: changedVal }) }}
                            />
                            {/* <AsynS fullWidth title="Search By  Name | Phone No " placeholder={"Search By  Name | Phone No  "} value={filters.search} onChange={(e) => { setFilters({ ...filters, search: e.target.value }) }} /> */}
                        </PaddingBoxInDesktop>
                    </FiltersBox>
                    <Box sx={{ minHeight: "300px" }} className="table">
                        <DataTable columns={columns} rows={list.result ? list.result : []} count={list.total ?? 0} filters={filters} setFilters={setFilters} loading={loading} />
                    </Box>
                </Paper>
            </Box>

        </>
    )
}
export default ListUi